module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp13_5.a0244390.png";